// app/src/services/mms/mock/entities-services/RfidRuleMockService.ts
import { RfidRuleServiceInterface } from "interfaces/rfidRule-service"
import { BaseMmsMockService } from "./BaseMockService.ts"
import { CommunicationService } from "services/mms/mock/CommunicationService.ts"

export class MockRfidRuleService extends BaseMmsMockService
    implements RfidRuleServiceInterface {
    constructor(communicationService: CommunicationService) {
        super(communicationService)
    }

    useGetRfidCardRule() {
        return {
            data: null,
            isLoading: false,
            error: null,
            refetch: vi.fn(),
            sendRequest: vi.fn().mockResolvedValue({ data: null, success: true, status: 200 }),
            success: true,
            status: 200
        }
    }

    useUpdateRfidCardRule() {
        return {
            data: {},
            mutate: vi.fn(),
            isLoading: false,
            error: null,
            sendRequest: vi.fn().mockResolvedValue({ data: {}, success: true, status: 200 }),
            success: true,
            status: 200
        }
    }
}